import type { SectionProps } from '@/components/sitemap/Section';
import { sharedConfig } from '@/pageConfig/shared';
import sections from '@/static/sitemap.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  section: SectionProps[];
}

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    ...sharedConfig['de-DE'].seo,
  },
  section: sections['de-DE'],
};
